import React from "react";
import ManOne from "../assets/images/vatel/banner-1-2025.png";
import { useSmoothScrollContext } from "../context/SmoothScrollContext";

const Banner = () => {
  const { handleLinkClick } = useSmoothScrollContext();

  return (
      <section
          id="home"
          className={`bg-[url('../images/banner/1.png')] bg-cover bg-no-repeat bg-center overflow-hidden`}
      >
        <div className="container relative">
          <div className="max-w-[570px] tw-pt-36 lg:tw-pt-[170px] md:pt-20 md:pb-20  pb-14 space-y-8">
            <h1 className="tw-text-5xl md:tw-text-6xl">
              Construisez<br/>
              votre avenir<br/>
              dans l'hôtellerie<br/>
              <span
                  className="text-secondary inline-block bg-[url('../images/banner/shape.svg')] bg-no-repeat bg-bottom">
              internationale
            </span><br/>
              avec Vatel
            </h1>
            <div className="plain-text text-gray leading-[30px]">
              Rejoignez l'école classée <strong>1<sup>re</sup> en France dans la catégorie Hospitality & Leisure Management</strong> selon le
              QS World University Rankings.
            </div>
            <a
                id="btn-brochure-hero"
                href="#brochure"
                onClick={(e) => handleLinkClick(e, 'brochure')}
                className="btn btn-primary w-full lg:w-auto inline-block text-center"
            >
              Demandez votre brochure
            </a>
          </div>
          <div className="imge-box absolute xl:tw-right-[-5px] hidden xl:block bottom-0">
            <img src={ManOne} alt="manOne" />
          </div>
        </div>
      </section>
  );
};

export default Banner;